import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import { bindActionCreators } from 'redux';
import * as ACTIONS from '../redux/actions/UI';

import { Block } from '../components';
import Visible from './Visible';
// import classnames from "classnames";

function mapDispatchToProps(dispatch) {
  return {
    projectScrolled: bindActionCreators(ACTIONS.projectScrolled, dispatch),
    projectUnscrolled: bindActionCreators(ACTIONS.projectUnscrolled, dispatch),
    setTemplate: bindActionCreators(ACTIONS.setTemplate, dispatch),
    setProjectHeight: bindActionCreators(ACTIONS.setProjectHeight, dispatch),
  };
}

class Project extends Component {
  projectHeight = 0;

  constructor(props) {
    super(props);
    this.state = {
      opacity: 1,
      atBottom: false,
    };
  }

  checkInterval = false;

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
    let _this = this;

    this.checkInterval = setInterval(() => {
      _this.handleResize();
    }, 1500);

    //this.props.setTemplate('project')
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    this.props.setProjectHeight(0);

    clearInterval(this.checkInterval);
  }

  handleResize = () => {
    //this.projectHeight = this.refs.project.offsetHeight
    if (this.refs.project) {
      this.props.setProjectHeight(this.refs.project.offsetHeight);
    }
  };

  handleScroll = () => {
    if (!this.props.loading) {
      let targ = this.refs.project;
      let y = window.scrollY;

      //console.log(targ.getBoundingClientRect())

      let rect = targ.getBoundingClientRect();
      // let top = rect.top + y;
      //let bottom = top + rect.height
      let wh = window.innerHeight;
      let start = y + wh;

      let totalHeight = rect.height;

      if (totalHeight <= start) {
        if (this.state.atBottom === false) {
          this.props.projectScrolled();
          this.setState({
            atBottom: true,
          });
        }

        let diff = start - totalHeight;
        let percentage = 100 - (diff / wh) * 100;
        let opacity = Math.round(percentage) / 100;

        this.setState({
          opacity: opacity,
        });
      } else {
        if (this.state.atBottom === true) {
          this.props.projectUnscrolled();
          this.setState({
            atBottom: false,
          });
          if (this.state.opacity !== 1) {
            this.setState({
              opacity: 1,
            });
          }
        }
      }

      /*if(start > bottom)
			{
				// animate space opacity


				
			} else {
				
			}*/
    }
  };

  /*componentDidUpdate(prevProps)
	{
		// check we're loaded

		if(prevProps.loading != this.props.loading)
		{
			this.handleResize()
		}
	}*/

  render() {
    let { entry, loading } = this.props;

    if (!entry) return null;

    if (loading) return <div className="Project Project--loading" />;

    let gridItems = entry.blocks.map((item, ix) => {
      return (
        <div
          key={ix}
          className={
            'Project-gridItem  Project-gridItem--' +
            item.style +
            ' Project-gridItem--' +
            item.blockType
          }
        >
          <Block block={item} />
        </div>
      );
    });

    let informationItems = entry.information.map((i, ix) => {
      return (
        <li key={ix} className="List-item">
          <span>{i.title}: </span>
          <span>{i.text}</span>
        </li>
      );
    });

    let style = null;

    if (entry.backgroundColour) {
      style = {
        backgroundColor: entry.backgroundColour,
      };
    }

    return (
      <div
        className="Project"
        data-project={entry.id}
        ref="project"
        style={style}
      >
        {entry.pageTitle && (
          <Helmet>
            <title>{entry.pageTitle}</title>
            <meta name="description" content={entry.metaDesc} />
          </Helmet>
        )}
        <div className="Project-head">
          {' '}
          <h1> {entry.title}</h1>
        </div>

        <div
          className="Project-content"
          style={{ opacity: this.state.opacity }}
        >
          <div className="Project-intro">
            <Visible>
              <h1> {entry.intro} </h1>
            </Visible>
          </div>

          <div className="Project-grid">{gridItems}</div>

          <div className="Project-foot">
            <ul className="List  List--information">{informationItems}</ul>
          </div>
        </div>

        <div className="Project-spacer" ref="spacer" />
      </div>
    );
  }
}

export default connect(null, mapDispatchToProps)(Project);



// WEBPACK FOOTER //
// ./src/js/components/Project.jsx